<template>
  <div class="rounded-md bg-white p-6 shadow-md">
    <div class="space-y-4" ref="results">
      <h2 class="mb-2 text-center text-xl font-semibold text-gray-700">
        Lista de facturas de América
      </h2>

      <div
        class="flex flex-col-reverse items-center space-y-4 space-y-reverse lg:flex-row lg:justify-between lg:space-y-0"
      >
        <button
          v-if="!isLoading"
          @click="showFilters = !showFilters"
          class="focus:shadow-outline inline-flex justify-center space-x-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:border-blue-300 focus:outline-none sm:text-sm"
        >
          <span class="text-center text-sm font-bold">Filtros</span>
          <SolidFilterIcon class="h-5 w-5" />
        </button>

        <button
          v-if="!isLoading"
          @click="downloadCsv"
          class="focus:shadow-outline inline-flex justify-center space-x-2 rounded-md bg-emerald-600 px-4 py-2 text-base font-medium text-white shadow-sm transition duration-150 ease-in-out hover:bg-emerald-700 focus:border-blue-300 focus:outline-none sm:text-sm"
        >
          <ExcelIcon class="h-5 w-5 fill-current" />
          <span class="text-center text-sm font-bold">Exportar</span>
        </button>
      </div>

      <transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <keep-alive>
          <FiltrosReporteFacturacion v-show="showFilters" @change:filter="onFilterChange" />
        </keep-alive>
      </transition>

      <transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <Cargando v-if="isLoading" key="1" />
        <Empty key="2" v-else-if="facturas.length === 0" />
        <div key="3" v-else class="space-y-3">
          <ListaFacturasAmerica :facturas="facturas" @refresh="fetchFacturas" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

import { useService } from '@colescba/app-vue'
import { useSession, useAcreditacionServicio } from '@colescba/ui'

import { useAccessControl } from '@/composables'

import ListaFacturasAmerica from '@/components/ListaFacturasAmerica'
import FiltrosReporteFacturacion from '@/components/FiltrosReporteFacturacion'
import Cargando from '@/components/Core/Cargando'
import Empty from '@/components/Core/Empty'
import ExcelIcon from '@/assets/icons/file-excel-solid.svg'

export default {
  name: 'Comprobantes',

  mixins: [useService('portalPagos'), useSession(), useAcreditacionServicio(), useAccessControl()],

  components: { ListaFacturasAmerica, FiltrosReporteFacturacion, Cargando, Empty, ExcelIcon },

  data() {
    return {
      isLoading: false,
      facturas: [],
      filtros: null,
      showFilters: true,
    }
  },

  async mounted() {
    //await this.fetchFacturas()
    this.fetchEstadosPago({ cuitCuil: this.user.cuitCuil.numero, portalPagos: this.portalPagos })
  },

  methods: {
    ...mapActions({
      fetchEstadosPago: 'app/fetchEstadosPago',
    }),
    async fetchFacturas() {
      this.isLoading = true
      this.facturas = await this.portalPagos.findFacturasReporte(
        this.user.cuitCuil.numero,
        this.buildFiltros()
      )
      this.isLoading = false
    },
    async downloadCsv() {
      this.isLoading = true
      let excel = await this.portalPagos.findFacturasReporteCsv(
        this.user.cuitCuil.numero,
        this.buildFiltros()
      )

      var blob = new Blob([excel], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      var a = document.createElement('a')
      a.href = window.URL.createObjectURL(blob)
      a.download = `reporte_${new Date().getTime()}.xlsx`
      a.style.display = 'none'
      a.click()

      this.isLoading = false
    },
    onFilterChange(filtros) {
      this.filtros = filtros
      this.fetchFacturas()
    },
    buildFiltros() {
      let filtros = {}
      if (this.filtros?.fechaCreacion.desde) {
        filtros['fecha_desde'] = moment(this.filtros?.fechaCreacion.desde).format('DD-MM-YYYY')
      }
      if (this.filtros?.fechaCreacion.hasta) {
        filtros['fecha_hasta'] = moment(this.filtros?.fechaCreacion.hasta).format('DD-MM-YYYY')
      }
      if (this.filtros?.sede_id) {
        filtros['sede_id'] = this.filtros?.sede_id
      }
      return filtros
    },
  },
}
</script>
